module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Mobilyze_image_6.e82a8fc1.png";